import { render, staticRenderFns } from "./States.vue?vue&type=template&id=97a2a2e6&scoped=true&"
import script from "./States.vue?vue&type=script&lang=js&"
export * from "./States.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a2a2e6",
  null
  
)

export default component.exports